import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Community(): ReactElement {
  return (
    <PageShell
      title="Community"
      intro="Austausch mit anderen Selbstständigen und dem Saldify-Team."
    >
      <PageSection title="Mitreden und mitgestalten">
        <p>
          Ihr Feedback prägt, wie sich Saldify weiterentwickelt. Wünsche,
          Funktionsideen und Verbesserungsvorschläge nehmen wir jederzeit gerne auf.
        </p>
      </PageSection>

      <PageSection title="Mitmachen">
        <p>
          Eine eigene Community-Plattform ist in Planung. Bis dahin erreichen Sie uns
          direkt unter{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>{' '}
          – wir freuen uns auf Ihre Ideen.
        </p>
      </PageSection>
    </PageShell>
  );
}
